import React, { useMemo } from 'react';
import { Badge, Tooltip } from 'antd';
import styles from './index.less';
import { ServiceRequestStatus } from '@/typings/models/ServiceRequest';
import {
  getServiceRequestStateTitles,
  SERVICE_REQUEST_STATUS_COLORS,
} from '@/components/Kanban/ServiceRequests/Calendar/utils';

interface AppointmentStatusBadgeProps {
  status: keyof typeof ServiceRequestStatus;
}

const AppointmentStatusBadge: React.FC<AppointmentStatusBadgeProps> = ({ status }) => {

  const badgeColor = SERVICE_REQUEST_STATUS_COLORS[status];
  const titles = useMemo(() => getServiceRequestStateTitles(), []);
  const tooltipText = titles[status];

  if (!badgeColor || !tooltipText) {
    return null;
  }

  return (
    <Tooltip title={tooltipText}>
      <div className={styles.statusBadgeContainer}>
        <Badge color={badgeColor} />
      </div>
    </Tooltip>
  );
};

export default AppointmentStatusBadge;
